import React, { Component } from 'react';
import ProductSlider from '../../slider/ProductSlider';
import MissingProductLoader from '../../product/MissingProductLoader';

class VehiclePartSlider extends Component {
  renderContent = (products) => {
    if (products.length === 0) {
      return null;
    }

    const { title } = this.props;

    return (
      <div className="VehiclePartAlternativesSlider">
        <h3>{title}</h3>
        <ProductSlider name={this.listName} products={products} />
      </div>
    );
  };

  render() {
    const { productIds } = this.props;

    return (
      <MissingProductLoader ids={productIds}>
        {(products) => this.renderContent(products)}
      </MissingProductLoader>
    );
  }
}

export default VehiclePartSlider;



// WEBPACK FOOTER //
// ./src/components/vehicle/VehiclePartSlider/index.jsx